import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "calendar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventModal = _resolveComponent("EventModal")!
  const _component_Agenda = _resolveComponent("Agenda")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_EventModal, {
          key: 0,
          showModal: _ctx.showModal,
          eventData: _ctx.currentEvent,
          mode: _ctx.mode,
          "onAdd:event": _ctx.createEvent,
          "onUpdate:event": _ctx.updateEvent,
          "onCancel:add:event": _ctx.cancelEvent,
          "onCancel:update:event": _ctx.cancelUpdateEvent
        }, null, 8, ["showModal", "eventData", "mode", "onAdd:event", "onUpdate:event", "onCancel:add:event", "onCancel:update:event"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Agenda, {
      openEventModal: _ctx.openEventModal,
      answers: _ctx.events,
      moveEvent: _ctx.moveEvent,
      durationChangeEvent: _ctx.durationChangeEvent,
      deleteEvent: _ctx.deleteEvent,
      currentLocale: _ctx.currentLocale(),
      showHintMessage: _ctx.showHintMessage,
      hideHintMessage: _ctx.hideHintMessage,
      startTime: "1",
      endTime: "24"
    }, null, 8, ["openEventModal", "answers", "moveEvent", "durationChangeEvent", "deleteEvent", "currentLocale", "showHintMessage", "hideHintMessage"])
  ]))
}